import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BusinessAccountLogicService, BusinessAccountMappedItem } from '@app/logic/business-accounts';
import { take } from 'rxjs';

interface IData {
    account: BusinessAccountMappedItem;
}

@Component({
    selector: 'cb-business-account-edit-financial-info-dialog',
    templateUrl: './business-account-edit-financial-info-dialog.component.html',
    styleUrls: ['./business-account-edit-financial-info-dialog.component.scss'],
    standalone: false
})
export class BusinessAccountEditFinancialInfoDialogComponent {
    public static readonly MIN_WIDTH = '60%';

    public bankName: string;
    public bankAccountNumber: string;
    public abmCode: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        public readonly dialogRef: MatDialogRef<BusinessAccountEditFinancialInfoDialogComponent>,
        private readonly businessAccountLogicService: BusinessAccountLogicService,
    ) {
    }

    public ngOnInit(): void {
        this.bankName = this.data.account.bankName;
        this.bankAccountNumber = this.data.account.bankAccountNumber;
        this.abmCode = this.data.account.abmCode;
    }

    public canSave(): boolean {
        return !!this.data?.account?.id && !!this.bankName && !!this.bankAccountNumber && !!this.abmCode;
    }

    public onSaveClicked(): void {
        if (this.canSave()) {
            this.businessAccountLogicService.editFinancialInfo(this.data.account.id, this.bankName, this.bankAccountNumber, this.abmCode)
                .pipe(take(1)).subscribe(() => this.dialogRef.close());
        }
    }
}
